module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-8-ab7e8c09afc2e36c87b3ac99f9318ed9.jpg";